/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2LeftArrowLong/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2LeftArrowLong({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2LeftArrowLong",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 8,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#52606D"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2LeftArrowLong.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 8"
 style={{'--as-1-Z1yrfnc': alignSelf,'--mt-2-Z1yrfnc': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1yrfnc': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1yrfnc': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1yrfnc': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1yrfnc': opacity,'--w-10-Z1yrfnc': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1yrfnc': typeof height === 'number' ? `${height}px` : height,'--f-12-Z1yrfnc': fill,'--a-7-Z1yrfnc': isAnimated ? animation : "none",'--sd-8-Z1yrfnc': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1yrfnc': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2LeftArrowLong.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M4.191.038A.5.5 0 014.5.5V3H13a1 1 0 110 2H4.5v2.5a.5.5 0 01-.854.354l-3.5-3.5a.5.5 0 010-.708l3.5-3.5a.5.5 0 01.545-.108z"
 style={{'--f-12-Z1yrfnc': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}